export default __webpack_public_path__ + "static/grafana-ca93f8dfeea855daa08e14a4c740956f.svg";